import { MODE_VIEW } from '@pages/objects/contents/profile/constants';

import { TPanelContainer } from '@molecules/sidePanelSelect';

import { SelectField } from '../SelectField';

type Props = {
    item: any;
    mode: string;
    selectedValues: Record<number, number>;
    valueLabels: Record<number, string>;
    customOptions: Record<number, { label: string; value: number }[]>;
    searchTexts: Record<number, string>;
    openStates: Record<number, boolean>;

    setOpenStates: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
    setValueLabels: React.Dispatch<React.SetStateAction<Record<number, string>>>;
    setSearchTexts: React.Dispatch<React.SetStateAction<Record<number, string>>>;

    getSelectRef: (id: number) => React.RefObject<any>;
    handleSearch: (id: number, text: string) => void;
    handleValueChange: (id: number, value: number) => void;
    addCustomOption: (id: number, value: string, ref: React.RefObject<any>) => void;
    onFieldBlur?: () => void;
    panelContainer?: TPanelContainer;
};

export const Field = ({
    item,
    mode,
    selectedValues,
    valueLabels,
    customOptions,
    searchTexts,
    openStates,
    setOpenStates,
    setValueLabels,
    setSearchTexts,
    getSelectRef,
    handleSearch,
    handleValueChange,
    addCustomOption,
    onFieldBlur,
    panelContainer,
}: Props) => {
    // В режиме просмотра показываем только текст
    if (mode === MODE_VIEW) {
        if (item.value && item.value.value) {
            return <span>{item.value.value}</span>;
        }

        const selectedValueId = selectedValues[item.id];
        if (selectedValueId !== undefined) {
            const displayValue = valueLabels[selectedValueId] || '-';
            return <span>{displayValue}</span>;
        }

        const availableValues = item.values || [];
        if (availableValues.length > 0) {
            return <span>{availableValues[0].value}</span>;
        }

        return <span>-</span>;
    }

    // В режимах создания и редактирования показываем селект для всех полей (включая обязательные)
    return (
        <SelectField
            item={item}
            mode={mode}
            selectedValues={selectedValues}
            valueLabels={valueLabels}
            customOptions={customOptions}
            searchTexts={searchTexts}
            openStates={openStates}
            setOpenStates={setOpenStates}
            setValueLabels={setValueLabels}
            setSearchTexts={setSearchTexts}
            getSelectRef={getSelectRef}
            handleSearch={handleSearch}
            handleValueChange={handleValueChange}
            addCustomOption={addCustomOption}
            onFieldBlur={onFieldBlur}
            panelContainer={panelContainer}
        />
    );
};
